import React from "react";
import styles from "../../../../styles/pages/user/copyrwriterdashboard_dev/pending-titling-wrapper.module.scss";
import { Box } from "@mui/system";
import { Button, Tab, Tabs, Typography } from "@mui/material";
import HamburgurIconBlack from "../../../../public/assets/icons/HamburgurIconBlack";
import Reloadicon from "../../../../public/assets/icons/Reloadicon";
import CopyWriterDashboardWrapper from "../../../../layout/wrapper/CopyWriterDashboardWrapper";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { useQuery } from "react-query";
// import CopyWriterCompletedVideoTable from "../../../../components/CopyWriterVideoTables/CopyWriterCompletedVideoTable";

const PendingTitlingWrapper = (props) => {
  const router = useLocation();
  const { data: submissionList } = useQuery(
    ["VIDEOList"],

    async () => {
      return Copywriterssubmissionsmutation({
        // pending_titling: 1,
        // page: page,
      });
    }
  );



  return (
    <>
      <CopyWriterDashboardWrapper chatbtn={true}>
        <Box className={styles.editorTab}>
          <Tabs aria-label="basic tabs example">
            <Tab
              className={
                router.pathname === "/copywriter-dashboard/pending-titling-page"
                  ? styles.tabItemSubmittedActive
                  : styles.tabItemSubmitted
              }
              label={
                <>
                  <Link to="/copywriter-dashboard/pending-titling-page">
                    <Box className={`${styles.tabItem}`}>
                      <Box className={styles.tabitemImg}>
                        <HamburgurIconBlack />
                      </Box>
                      <p>
                        Pending Titling
                        <span>
                          {submissionList?.data?.submissions?.pendingTitling}
                        </span>
                      </p>
                    </Box>
                  </Link>
                </>
              }
            />
            <Tab
              className={
                router.pathname ===
                "/copywriter-dashboard/pending-titling/revised"
                  ? styles.tabItemSubmittedActive
                  : styles.tabItemSubmitted
              }
              label={
                <>
                  <Link to="/copywriter-dashboard/pending-titling/revised">
                    <Box className={`${styles.tabItem}`}>
                      <Box className={styles.tabitemImg}>
                        <Reloadicon />
                      </Box>
                      <p>
                        Pending Revision
                        <span>
                          {submissionList?.data?.submissions?.pendingRevision}
                        </span>
                      </p>
                    </Box>
                  </Link>
                </>
              }
            />
          </Tabs>
        </Box>
        {props.children}
      </CopyWriterDashboardWrapper>
    </>
  );
};

export default PendingTitlingWrapper;
